<template>
  <Form @submit="onSubmit">
    <div class="flex border-b border-dark-b">
      <h2 class="text-xl md:text-2xl font-semibold w-9/12 md:w-1/2">Identity Documents</h2>
      <div class="flex lg:pl-2 text-xs items-center md:w-1/2 justify-end md:justify-between">
        <div>Progress</div>
        <div class="flex md:w-10/12 items-center justify-between">
          <div class="hidden md:inline w-1/5 h-2 ml-2 bg-green rounded-full"/>
          <div class="hidden md:inline w-4/5 h-2 bg-white rounded-r-full"/>
          <div class="pl-2 text-green md:text-black">20%</div>
        </div>
      </div>
    </div>
    <div class="flex flex-wrap w-full pt-7 md:pt-12">
      <div class="lg:pr-5 w-full font-semibold text-lg lg:text-xl lg:w-1/2">
        <div class="pb-1">ID Proof Type<span class="text-error">*</span></div>
        <Field
          name="idType"
          class="form-input text-sm md:text-lg"
          placeholder="Type ID Proof Type & e.g. Govt. ID, Passport here..."
          :rules="isRequired"
          v-model="formData.id_proof_type"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="idType" class="form-error"/>
        </div>
      </div>
      <div class="lg:pl-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">ID Number/Passport Number<span class="text-error">*</span></div>
        <Field
          name="passport"
          class="form-input text-sm md:text-lg"
          placeholder="Type ID Number/Passport Number here..."
          :rules="isRequired"
          v-model="formData.passport"
        />
        <div class="h-5 md:h-8">
          <ErrorMessage name="passport" class="form-error"/>
        </div>
      </div>     
    </div>
    <div class="flex flex-wrap w-full">
      <div class="lg:pr-5 font-semibold text-lg lg:text-xl w-full lg:w-1/2">
        <div class="pb-1">
          ID Proof Document<span class="text-error">*</span>
        </div>
        <div 
          class="relative flex items-center"
          :class="[formData.id_proof_document && formData.id_proof_document[0] ? 'h-12 w-full' : 'form-input' ]">
          <Field
            name="id_proof_document"
            type="file"
            class="absolute inset-0 opacity-0 z-10 w-full overflow-hidden"
            :rules="fileRequired"
            v-model="formData.id_proof_document"
          />
          <span
            v-if="formData.id_proof_document && formData.id_proof_document[0]"
            class="pointer-events-none absolute z-10 left-0 pl-4 w-4/6 truncate text-blue text-lg lg:text-xl font-normal"
          >
            {{ formData.id_proof_document[0].name }}
          </span>
          <span
            v-else
            class="pointer-events-none absolute text-sm md:text-lg font-normal z-10 left-0 px-4 opacity-50"
          >
            Pdf or jpeg Max File Size 2MB
          </span>
          <div v-if="formData.id_proof_document && formData.id_proof_document[0]" class="w-9/12 z-10 pointer-events-none">
            <img src="@/assets/icons/closeBlack.svg" class="ml-auto z-20 pointer-events-auto cursor-pointer" @click="formData.id_proof_document = null"/>
          </div>
          <img v-if="formData.id_proof_document && formData.id_proof_document[0]" src="@/assets/icons/uploadBlack.svg" class="ml-auto w-11 h-11">
          <img v-else src="@/assets/icons/upload.svg" class="ml-auto w-4-5 h-4-5">
        </div>
        <div class="h-2 md:h-9">
          <ErrorMessage name="id_proof_document" class="form-error"/>
        </div>
      </div>
    </div>
    <div class="flex justify-end pt-6 pb-6">
      <button
        class="bg-blue text-white py-3 px-8 text-lg lg:text-xl rounded-full font-bold"
      >
        Save
      </button>
    </div>
  </Form>
</template>
<script>
import { mapActions } from 'vuex'
import VeeValidate from '@/shared/mixins/VeeValidate'

export default {
  name: 'IdentityDocuments',
  mixins: [VeeValidate],
  data() {
    return {
      formData: {},
    }
  },
  methods: {
    ...mapActions([
      'updateIdentityInfo'
    ]),
    async onSubmit() {
      const response = await this.updateIdentityInfo(this.formatFormData())
      this.$notify({
        group: 'buyHive',
        type: response.result ? 'success' : 'error',
        text: response.message
      })
    },
    formatFormData() {
      const userData = new FormData()
      Object.keys(this.formData).forEach(key => {
        if (key !== 'id_proof_document') userData.append(key, this.formData[key] || '')
      })
      userData.append('id_proof_document', this.formData.id_proof_document[0])
      userData.append('_method', 'PUT')
      return userData
    }

  }
}
</script>
